module.exports = __webpack_public_path__ + "img/kcjs-kjxj.7530990d.png";